export default __webpack_public_path__ + "static/media/F0001.d1814755.png";